import { useState, FunctionComponent } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom'

import { Container } from '@mui/material';

import CollectionWizard from 'components/collection/wizard/CollectionWizard';

const Collection: FunctionComponent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  const cancelClicked = () => {
    navigate(-1);
  }

  return (<>
    <Container maxWidth="md">
        <CollectionWizard 
          id={id}
          firstBackText="Cancel" 
          finishedText="Save" 
          onFinished={() => navigate(-1)}
          cancelled={cancelClicked}/>
    </Container>    
  </>);
}
export default Collection;